/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Clear_LabelInputs */



/**
* | output |
* | --- |
* | "Remove stem" |
*
* @param {Audio_Stems_Clear_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_clear_label = /** @type {((inputs?: Audio_Stems_Clear_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Clear_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer la piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stem entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить дорожку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除音轨")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ステムを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टेम हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover faixa")
	return /** @type {LocalizedString} */ ("Remove stem")
});